<div 
  class="download-button" 
  [class.disabled]="isDownloading" 
  (click)="downloadDocument()"
  (keyup.enter)="downloadDocument()"
  (keydown.space)="downloadDocument()"
  tabindex="0"
  role="button"
  [attr.aria-label]="buttonText"
>
  <div class="button-content">
    <img *ngIf="!isDownloading" src="assets/icon/download-file-icon.svg" alt="download icon" />
    <ion-spinner *ngIf="isDownloading" name="lines" class="download-spinner"></ion-spinner>
    <span>{{ isDownloading ? 'Скачивание...' : buttonText }}</span>
  </div>
</div> 